module.exports = ["cent","copy","divide","gt","lt","not","para","times"]


//////////////////
// WEBPACK FOOTER
// ./~/stringify-entities/dangerous.json
// module id = 199
// module chunks = 96961042003272 139266963665775